import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { FileBadge, Upload, X } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

/**
 * Certificazione di qualità / dichiarazione di conformità del fornitore MOCA
 * (usato anche per la scheda di sicurezza dei prodotti sanificanti): un PDF o una foto. Dal telefono si può scegliere se fotografare o prendere il file.
 */
export default function MocaCertificateUpload({ value = [], onChange, label = "Carica la certificazione", testid = "moca-cert", successMessage = "Certificazione allegata" }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const added = [];
      for (const file of files) {
        const fd = new FormData(); fd.append("file", file);
        const { data } = await api.post("/app/catalog/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
        added.push({ url: data.url, name: data.name });
      }
      onChange([...value, ...added]);
      toast.success(successMessage);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  return <div className="space-y-2" data-testid={testid}>
    {value.map((doc, index) => <div key={doc.url} className="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800">
      <FileBadge className="h-4 w-4 shrink-0" /><span className="min-w-0 flex-1 truncate">{doc.name}</span>
      <button type="button" onClick={() => onChange(value.filter((_, i) => i !== index))} className="grid h-9 w-9 place-items-center rounded-full hover:bg-emerald-100" aria-label={`Rimuovi ${doc.name}`}><X className="h-4 w-4" /></button>
    </div>)}
    <input ref={input} type="file" accept="application/pdf,image/*" className="hidden" onChange={(e) => upload(e.target.files)} data-testid={`${testid}-input`} />
    <button type="button" disabled={busy} onClick={() => input.current?.click()} className="inline-flex min-h-[44px] items-center gap-2 rounded-lg border border-navy/30 bg-white px-3 text-sm font-semibold text-navy hover:bg-slate-50 disabled:opacity-60" data-testid={`${testid}-button`}>
      <Upload className="h-4 w-4" /> {busy ? "Caricamento…" : label}
    </button>
  </div>;
}
